import validate from "/app/node_modules/.pnpm/nuxt@3.21.6_@parcel+watcher@2.5.6_@types+node@24.12.4_@vue+compiler-sfc@3.5.34_cac@6.7._5fb85f7cd389bdca4523d1116a45d9d0/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.21.6_@parcel+watcher@2.5.6_@types+node@24.12.4_@vue+compiler-sfc@3.5.34_cac@6.7._5fb85f7cd389bdca4523d1116a45d9d0/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-eig-id-param": () => import("/app/packages/frontend-bo/src/middleware/check-eig-id-param.js"),
  "check-feature-flags": () => import("/app/packages/frontend-bo/src/middleware/check-feature-flags.ts"),
  "check-role": () => import("/app/packages/frontend-bo/src/middleware/check-role.js"),
  "is-connected": () => import("/app/packages/frontend-bo/src/middleware/is-connected.js"),
  "redirect-on-hebergements": () => import("/app/packages/frontend-bo/src/middleware/redirect-on-hebergements.js")
}